import React, { useContext } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Button from 'components/Button';
import Input from 'components/Input';
import Switcher from 'components/Switcher';
import SearchUserInput from 'components/SearchUserInput/SearchUserInput';

import { ModalContext } from 'components/ModalProvider/ModalProvider';
import SVG from 'components/SVG';

import useCreateCashback from '../../../../model/useCreateCashback';
import closeSVG from '../../../../data/img/close.svg';

import './CashbackEditor.scss';

const b = block('cashback-editor-desktop');

const CashbackEditor = () => {
  const locale = useSelector(s => s.locale.locale);
  const { closeModal } = useContext(ModalContext);
  const { values, handlers } = useCreateCashback(closeModal);

  return (
    <article className={b()}>
      <div className={b('header')}>
        <h2 className={b('title')}>{locale.cashbackCreation}</h2>
        <div className={b('close-button')}>
          <SVG svgProps={{ svg: closeSVG }} onClick={() => closeModal()} />
        </div>
      </div>

      <form className={b('form')} onSubmit={handlers.handleSubmit}>
        <div className={b('form-group')}>
          <div className={b('provider-tabs')}>
            <button
              type="button"
              className={b('provider-tab', { active: values.state.providerType.value === 'casino' })}
              onClick={() => handlers.handleProviderTypeChange('casino')}>
              {locale.onTheSlots}
            </button>
            <button
              type="button"
              className={b('provider-tab', { active: values.state.providerType.value === 'sport' })}
              onClick={() => handlers.handleProviderTypeChange('sport')}>
              {locale.sport}
            </button>
          </div>
        </div>

        <div className={b('form-row')}>
          <div className={b('form-group')}>
            <label className={b('label')}>{locale.numberOfDays}</label>
            <Input
              type="number"
              value={values.state.durationDays}
              onChange={e => handlers.handleDurationDaysChange(e.currentTarget.value)}
              placeholder={locale.numberOfDays}
              min="1"
              max="365"
            />
          </div>

          <div className={b('form-group')}>
            <label className={b('label')}>{locale.percentReembolso}</label>
            <Input
              type="number"
              value={values.state.cashbackPercent}
              onChange={e => handlers.handleCashbackPercentChange(e.currentTarget.value)}
              placeholder={locale.percentReembolso}
              step="0.01"
              min="0.01"
              max="100"
            />
          </div>
        </div>

        {!values.state.isForAllPlayers && (
          <div className={b('form-group')}>
            <label className={b('label')}>{locale.selectPlayer}</label>
            <SearchUserInput
              filterValue={values.state.filterValue}
              handleSearchChange={handlers.handleSearchChange}
              handleResultClick={handlers.handleResultClick}
              searchResult={values.state.searchResult}
              isLoadingSearchResult={values.state.isLoadingSearchResult}
              placeholder={locale.selectPlayer}
              locale={locale}
            />
          </div>
        )}

        <div className={b('form-group', { switcher: true })}>
          <label className={b('label')}>{locale.toAllPlayers}</label>
          <div className={b('form-group-switcher')}>
            <Switcher
              isActive={values.state.isForAllPlayers}
              onSwitch={() => handlers.handleIsForAllPlayersChange(!values.state.isForAllPlayers)}
            />
          </div>
        </div>

        <div className={b('button-wrapper')}>
          <Button text={locale.createNewCashback} callBack={handlers.handleSubmit} disabled={values.disabled} />
        </div>
      </form>
    </article>
  );
};

export default CashbackEditor;
